import ContentPageTemplate from '@/components/ContentPageTemplate';
import { marketingPages } from '@/data/marketingPages';

export default function ContactUsPage() {
  return <ContentPageTemplate page={marketingPages['contact-us']} />;
}
